module.exports = __webpack_public_path__ + "static/twinMotion1-376494be73c30506e6d8e74ac7e7b708.png";